import { render, staticRenderFns } from "./NewTrasladoCerdo.vue?vue&type=template&id=d8045ae6"
import script from "./NewTrasladoCerdo.vue?vue&type=script&lang=js"
export * from "./NewTrasladoCerdo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports